module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v(_vm._s(_vm.$t('groupPages.modules.links.title')))]), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover table-striped audios"
  }, [_c('tbody', {
    directives: [{
      name: "sortable",
      rawName: "v-sortable",
      value: ({
        onUpdate: _vm.onListReorder,
        handle: '.drag-handle'
      }),
      expression: "{onUpdate: onListReorder, handle: '.drag-handle'}"
    }]
  }, _vm._l((_vm.items), function(file) {
    return _c('tr', {
      staticClass: "clickable",
      on: {
        "click": function($event) {
          return _vm.showFile(file)
        }
      }
    }, [_vm._m(0, true), _c('td', [_vm._v(_vm._s(file.description))]), (_vm.openEditor) ? _c('td', [_vm._v("   "), _c('i', {
      staticClass: "text-danger fa fa-trash",
      on: {
        "click": function($event) {
          return _vm.remove(file, $event)
        }
      }
    })]) : _vm._e()])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "30px"
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b384530","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GroupPages/GroupPageLinks.vue
// module id = 1246
// module chunks = 2